export const FINAL_ASSIGNMENT_NAME = 'Final';

export const resolveIsFinalAssignment = (assignment: {
  name: string;
  isFinal?: boolean | null;
}): boolean => assignment.isFinal ?? assignment.name === FINAL_ASSIGNMENT_NAME;
